import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { Row, Form } from "react-bootstrap";
import { Link } from "react-router-dom";

import Button from "../../../../components/common/button/Button";
import Textarea from "../../../../components/common/textarea/Textarea";
import Radio from "../../../../components/common/radio/Radio";
import { maxLength } from "../../../../utils/forms/validators";
import emptyStarIcon from "../../../../assets/images/empty-star.svg";
import filledStarIcon from "../../../../assets/images/filled-star.svg";
import Ratings from "./Ratings";

import styles from "./EmployerReview.scss";

const anythingElse = maxLength(
  2500,
  "This field must be less than or equal to 2500 characters."
);

class EmployerReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  render() {
    const { handleSubmit, submitting, pristine, invalid } = this.props;

    return (
      <div className={styles.employerReview}>
        <Form onSubmit={handleSubmit}>
          <Row>
            <h2>Project Review</h2>
            <div className={styles.pageSubTitle}>
              Please take a minute to review your experience with this project.
              The company you worked with will not see the answers you submit.
            </div>
          </Row>

          <Row>
            <div className={styles.divider} />
            <div className={styles.divider} />
          </Row>

          {this.renderSection()}

          <div className={styles.CTAContainer}>
            <Button
              isPrimary
              size={"large"}
              type="submit"
              label="Submit"
              isDisabled={invalid || submitting || pristine}
            />
            <div>
              <Link to="/member/projects/matches" className={styles.decline}>
                Skip this step ›
              </Link>
            </div>
          </div>
        </Form>
      </div>
    );
  }

  renderSection() {
    return this.props.sections.map((section, index) => {
      const title = this.replaceWithName(section.title);

      return (
        <div key={index}>
          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>{title}</h2>
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              {this.renderQuestions(section.questions_member)}
            </div>
          </Row>
        </div>
      );
    });
  }

  renderQuestions(questions) {
    const componentTypes = {
      contact: this.renderContact,
      radio: this.renderRadio,
      rating: this.renderRating,
      text: this.renderTextarea
    };

    return (
      questions &&
      questions.map(question => {
        question.text = this.replaceWithName(question.question);
        return (
          componentTypes[question.type.name] &&
          componentTypes[question.type.name](question)
        );
      })
    );
  }

  renderRating(question) {
    return (
      <Field
        name={question.id.toString()}
        key={question.id.toString()}
        component={Ratings}
        emptyIcon={emptyStarIcon}
        filledIcon={filledStarIcon}
        text={question.text}
      />
    );
  }

  renderTextarea(question) {
    return (
      <div>
        <p className={styles.radioGroupQuestion}>{question.text}</p>
        <Field
          name={question.id.toString()}
          key={question.id.toString()}
          type="textarea"
          //placeholder={question.text}
          component={Textarea}
          //help="2,500 characters max"
          maxlength={2500}
          validate={anythingElse}
        />
      </div>
    );
  }

  renderRadio(question) {
    return (
      <div key={question.id.toString()}>
        <p className={styles.radioGroupQuestion}>{question.text}</p>

        <div className={styles.radioGroupContainer}>
          <Field
            name={question.id.toString()}
            component={Radio}
            type="radio"
            value={true}
            text="Yes"
            parse={val => val === "true"}
            handleChange={e => (e.target.checked = true)}
          />
          <Field
            name={question.id.toString()}
            component={Radio}
            type="radio"
            value={false}
            text="No"
            parse={val => val === "true"}
            handleChange={e => (e.target.checked = true)}
          />
        </div>
      </div>
    );
  }

  renderContact(question) {
    return (
      <div key={question.id.toString()}>
        <p className={styles.question}>{question.text}</p>
        <div className={styles.contactInfo}>
          <div className={styles.contactInfoInput}>
            <Field
              name={`names[${question.id}]`}
              type="text"
              placeholder="Contact Name"
              component={Input}
            />
          </div>
          <div className={styles.contactInfoInput}>
            <Field
              name={`emails[${question.id}]`}
              type="text"
              placeholder="Contact Email"
              component={Input}
              validate={[emailValidation]}
            />
          </div>
        </div>
      </div>
    );
  }

  replaceWithName(text) {
    return text ? text.replace("{{name}}", this.props.employerName) : null;
  }
}

export default reduxForm({
  form: "EmployerReview",
  initialValues: {}
})(EmployerReview);



// WEBPACK FOOTER //
// ./src/routes/candidate/employerReview/components/EmployerReview.js